import { useEffect } from 'react';

const OFFSET_TOP = '--vv-offset-top';
const HEIGHT = '--vv-height';
const LAYOUT_BOTTOM_GAP = '--vv-layout-bottom-gap';

function updateVisualViewportCssVars() {
  const root = document.documentElement;
  const vv = window.visualViewport;
  if (!vv) {
    root.style.setProperty(OFFSET_TOP, '0px');
    root.style.setProperty(HEIGHT, `${window.innerHeight}px`);
    root.style.setProperty(LAYOUT_BOTTOM_GAP, '0px');
    return;
  }
  root.style.setProperty(OFFSET_TOP, `${vv.offsetTop}px`);
  root.style.setProperty(HEIGHT, `${vv.height}px`);
  const gap = Math.max(0, window.innerHeight - vv.offsetTop - vv.height);
  root.style.setProperty(LAYOUT_BOTTOM_GAP, `${gap}px`);
}

export function useVisualViewportCssVars() {
  useEffect(() => {
    updateVisualViewportCssVars();
    const vv = window.visualViewport;
    if (!vv) {
      window.addEventListener('resize', updateVisualViewportCssVars);
      return () =>
        window.removeEventListener('resize', updateVisualViewportCssVars);
    }
    vv.addEventListener('resize', updateVisualViewportCssVars);
    vv.addEventListener('scroll', updateVisualViewportCssVars);
    window.addEventListener('resize', updateVisualViewportCssVars);
    return () => {
      vv.removeEventListener('resize', updateVisualViewportCssVars);
      vv.removeEventListener('scroll', updateVisualViewportCssVars);
      window.removeEventListener('resize', updateVisualViewportCssVars);
    };
  }, []);
}
